import loadable, { DefaultComponent } from '@loadable/component';
import React, { ReactElement } from 'react';

import FormConfirmationProps from './FormConfirmationProps';

const FormConfirmation = loadable(
    (): Promise<DefaultComponent<FormConfirmationProps>> => import(/* webpackChunkName: "FormConfirmation" */ './FormConfirmation'),
);
const FormConfirmationLoader = (props: FormConfirmationProps): ReactElement => <FormConfirmation {...props} />;
export default FormConfirmationLoader;
